export default "__VITE_ASSET__DqCxfdE0__"